export const dateFormats = {
  dateFormat: "MM-DD-YYYY",
  timeFormat: "hh:mm A",
  datetimeFormat: "MM-DD-YYYY hh:mm A",
};